$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  const location_id = $('body').attr('event_id');
  const customer_id = $('body').attr('customer_id');

  if (p === 'customer_contact_person') {
    $(document).on('submit', '#customer-contact-person-reg-form', function (e) {
      e.preventDefault();
      $('.customer-contact-person-form-button').attr('disabled', true);
      const formData = new FormData(e.target);
      $.ajax({
        type: 'POST',
        url: `/api/v1/private/customer-contact-person/new`,
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          $('.customer-contact-person-form-button').attr('disabled', false);
          if (data.message !== undefined && data.message !== null) {
            $('.card-box-to-hide').hide();
            prependAlert(
              '#customer-contact-person-reg-form',
              data.message,
              'success',
              null
            );

            if (data.redirect_url) {
              setTimeout(function () {
                document.location.href = data.redirect_url;
              }, 2000);
            } else {
              setTimeout(function () {
                document.location.href =
                  '/location/' +
                  location_id +
                  '/customer/' +
                  customer_id +
                  '/contact_person';
              }, 2000);
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          $('.customer-contact-person-reg-form-button').attr('disabled', false);

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            $('.card-box-to-hide').hide();
            prependAlert(
              '#customer-contact-person-reg-form',
              data.responseJSON.error_message,
              'danger',
              null
            );
          }
        });
    });
    $(document).on(
      'submit',
      '#customer-contact-person-update-form',
      function (e) {
        e.preventDefault();
        $('.customer-contact-person-form-button').attr('disabled', true);
        const formData = new FormData(e.target);
        $.ajax({
          type: 'POST',
          url: `/api/v1/private/customer-contact-person/update`,
          data: formData,
          enctype: 'multipart/form-data',
          async: true,
          cache: false,
          processData: false,
          contentType: false,
        })
          .done(function (data) {
            $('.customer-contact-person-form-button').attr('disabled', false);
            if (data.message !== undefined && data.message !== null) {
              prependAlert(
                '#customer-contact-person-update-form',
                data.message,
                'success',
                null
              );

              $('.card-box-to-hide').hide();

              if (data.redirect_url) {
                setTimeout(function () {
                  document.location.href = data.redirect_url;
                }, 2000);
              } else {
                setTimeout(function () {
                  document.location.href =
                    '/location/' +
                    location_id +
                    '/customer/' +
                    customer_id +
                    '/contact_person';
                }, 2000);
              }
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            $('.customer-contact-person-form-button').attr('disabled', false);

            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              prependAlert(
                '#customer-contact-person-update-form',
                data.responseJSON.error_message,
                'danger',
                null
              );
            }
          });
      }
    );

    $(document).on(
      'hide.bs.modal',
      '.customer-contact-person-delete-modal',
      function () {
        $(this).remove();
        $('.modal-backdrop').remove();
      }
    );

    $(document).on(
      'click',
      '.customer-contact-person-delete-confirm',
      function () {
        let customer_contact_person_id = $(this).attr('data-delete-id');

        $.ajax({
          type: 'POST',
          url: `/api/v1/private/customer-contact-person/delete`,
          data: {
            customer_contact_person_id,
            location_id,
          },
        })
          .done(function (data) {
            if (data.message !== undefined && data.message !== null) {
              alert(data.message);
            } else {
              $(
                'tr#customer-contact-person-' + customer_contact_person_id
              ).fadeOut(1000);
              setTimeout(function () {
                $(
                  'tr#customer-contact-person-' + customer_contact_person_id
                ).remove();
              }, 1000);

              // Mobile fadeOut.
              $(
                '#mobile-customer-contact-person-' + customer_contact_person_id
              ).fadeOut(1000);
              setTimeout(function () {
                $(
                  '#mobile-customer-contact-person-' +
                    customer_contact_person_id
                ).remove();
              }, 1000);
              popupAlert();
            }
            $('.customer-contact-person-delete-modal').modal('hide');
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              $('#customer-contact-person-' + customer_contact_person_id).after(
                '<tr><td colspan="6"><div class="alert alert-danger alert-dismissible" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>' +
                  data.responseJSON.error_message +
                  '</div></td></tr>'
              );
            }
            $('.customer-contact-person-delete-modal').modal('hide');
          });

        return false;
      }
    );
  }
});
